import axios from "axios";
import {
  CompanyManagementService_URL,
  SystemService_URL,
  UserService_URL,
} from "../Url";
import HashMap from "hashmap";
import { getCurrentPageName } from "../../containers/listing/PageModule";

var map = new HashMap();
//////////////////////////////////////////////////////////////////////////////////////////////
function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

// get current page name in caps
let PageName = getCurrentPageName();

// set action type on page url {e.g "locationList" }
const FETCH_REQUEST = "FETCH_" + PageName;
const FETCH_FULFILLED = "FETCH_" + PageName + "_FULFILLED";
const FETCH_REJECTED = "FETCH_" + PageName + "_REJECTED";

// update listAction on page change
export function listActions(type) {
  if (type) {
    return (ListActions = {
      FETCH_LIST: type.FETCH_REQUEST,
      FETCH_LIST_FULFILLED: type.FETCH_FULFILLED,
      FETCH_LIST_REJECTED: type.FETCH_REJECTED,
      SET_APPLICATION_ERROR: "SET_APPLICATION_ERROR",
      LOGOUT: "LOGOUT",
    });
  }
}

// onload listActions
export let ListActions = {
  FETCH_LIST: FETCH_REQUEST,
  FETCH_LIST_FULFILLED: FETCH_FULFILLED,
  FETCH_LIST_REJECTED: FETCH_REJECTED,
  SET_APPLICATION_ERROR: "SET_APPLICATION_ERROR",
  LOGOUT: "LOGOUT",
};

// service call
export function getListing(props = {}) {
  const search = props.search || "";
  // const statusID = props.statusID || "0";
  const status = props.status;
  const result = props.result || "10";
  const page = props.page || "0";
  const companyId = props.companyId;
  const sortOrder = props.sortOrder === false ? "asc" : "desc" || "desc";
  const searchCol = (props.search === null ? "" : props.searchCol) || "";
  const access_token = props.access_token;
  // const dmcId = props.dmcId;

  PageName = getCurrentPageName();

  // set handler as per page, set your page url in caps
  let handler = "";
  let methodType = "";

  // let data = [
  //   {
  //     columnID: 0,
  //     sequenceColumn: 0,
  //   },
  // ];
  if (PageName === "COMPANYMASTER") {
    methodType = "POST";
    const sortField = props.sortField || "companyName";

    handler =
      `${CompanyManagementService_URL}/getAllCompanyDetailsPagination?start=` +
      page +
      `&length=` +
      result +
      `&sortOrder=` +
      sortOrder +
      `&sortField=` +
      sortField +
      `&search=` +
      search +
      `&searchCol=` +
      searchCol +
      `&status=` +
      status;
  } else if (PageName === "SUBSCRIPTIONMASTER") {
    methodType = "POST";
    const sortField = props.sortField || "planName";
    handler =
      `${CompanyManagementService_URL}/getAllSubscriptionPlansPagination?start=` +
      page +
      `&length=` +
      result +
      `&sortOrder=` +
      sortOrder +
      `&sortField=` +
      sortField +
      `&search=` +
      search +
      `&searchCol=` +
      searchCol +
      `&status=` +
      status;
  } else if (PageName === "COMPANYMASTERUSERLISTING") {
    methodType = "POST";
    const sortField = props.sortField || "userFirstName";
    handler =
      `${UserService_URL}/getAllCompanyUserByPagination?start=` +
      page +
      `&length=` +
      result +
      `&sortOrder=` +
      sortOrder +
      `&sortField=` +
      sortField +
      `&search=` +
      search +
      `&status=` +
      status +
      `&searchCol=` +
      searchCol +
      `&companyId=` +
      companyId;
  }
  return (dispatch) =>
    axios({
      method: methodType,
      // data: data,
      // url: `http://demo4521367.mockable.io/getAllAssetTypePagination`,
      url: `${handler}`,
      headers: {
        Authorization: "Bearer " + access_token,
        "Content-Type": "application/json",
        transactionId: "1",
      },
    })
      .then((response) => {
        dispatch(applicationUsersRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(applicationUsersSuccess(response));
          return response;
        } else if (response.status === 401) {
        } else {
          const error = new Error(response.statusText);
          dispatch(applicationUsersError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(applicationUsersError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(applicationUsersError(err));
              break;
            case 500:
              dispatch(applicationUsersError("Server Error"));
              break;
            default:
              dispatch(applicationUsersError("Unknown Error"));
              break;
          }
        } else {
          // dispatch(logout());
        }
      });
}

export function applicationUsersRequest() {
  // set type on req
  let type = {
    FETCH_REQUEST: "FETCH_" + PageName,
    FETCH_FULFILLED: "FETCH_" + PageName + "_FULFILLED",
    FETCH_REJECTED: "FETCH_" + PageName + "_REJECTED",
  };
  listActions(type);

  return {
    type: type.FETCH_REQUEST,
    isPosting: true,
  };
}
export function applicationUsersError(error) {
  return {
    type: ListActions.FETCH_LIST_REJECTED,
    payload: error,
  };
}

export function logout() {
  return {
    type: ListActions.LOGOUT,
    payload: "Session Expired. Please Login Again",
  };
}

export function applicationUsersSuccess(props) {
  // set type on req
  let type = {
    FETCH_REQUEST: "FETCH_" + PageName,
    FETCH_FULFILLED: "FETCH_" + PageName + "_FULFILLED",
    FETCH_REJECTED: "FETCH_" + PageName + "_REJECTED",
  };
  listActions(type);

  return (dispatch) => {
    dispatch({
      type: type.FETCH_FULFILLED,
      payload: props,
    });
  };
}

export function setApplicationError() {
  return (dispatch) => dispatch(setErrorRequest());
}

export function setErrorRequest() {
  return {
    type: ListActions.SET_APPLICATION_ERROR,
  };
}

///////////////////////////////////////////////////////////////////////////
////////////////////////////////////Update Active Inactive Status/////////////
export const updateActiveInactiveActions = {
  UPDATE_STATUS: "UPDATE_STATUS",
  // SAVE_LOCATION_STATUS: 'UPDATEAINA_STATUS_LOCATION_STATUS',
  UPDATE_STATUS_SUCCESS: "UPDATE_STATUS_SUCCESS",
  UPDATE_STATUS_FAILURE: "UPDATE_STATUS_FAILURE",
  // FETCH_LOCATION_MASTER: 'FETCH_LOCATION_MASTER',
  SET_UPDATE_ERROR: "SET_UPDATE_ERROR",
  // LOGOUT:'LOGOUT'
};

export function updateStatusRequest() {
  return {
    type: updateActiveInactiveActions.UPDATE_STATUS,
    isPosting: true,
  };
}

export function updateStatusSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: updateActiveInactiveActions.UPDATE_STATUS_SUCCESS,
      payload: props,
    });
  };
}

export function updateStatusFailure(error) {
  return {
    type: updateActiveInactiveActions.UPDATE_STATUS_FAILURE,
    payload: error,
  };
}

export function updateActiveInactive(props) {
  let handler = "";
  if (PageName === "COMPANYMASTER") {
    handler =
      `${CompanyManagementService_URL}/deleteCompanyById?id=` +
      props.id +
      `&status=` +
      props.isActive;
  } else if (PageName === "SUBSCRIPTIONMASTER") {
    handler =
      `${CompanyManagementService_URL}/deleteSubscriptionPlansById?id=` +
      props.id +
      `&status=` +
      props.status;
  } else if (PageName === "HOSTINGPROVIDERMASTER") {
    handler =
      `${SystemService_URL}/deleteHostingProviderMaster?hostProviderId=` +
      props.hostingProviderId +
      `&active=` +
      props.isActive;
  } else if (PageName === "DATASUBJECTCATEGORIES") {
    handler =
      `${SystemService_URL}/deleteDataSubjectCategoryMaster?dataSubjectCategoryId=` +
      props.dataSubjectCategoryId +
      `&active=` +
      props.isActive;
  } else if (PageName === "DATADISPOSALMASTER") {
    handler =
      `${SystemService_URL}/deleteDataDisposalMaster?dataDisposalId=` +
      props.dataDisposalId +
      `&active=` +
      props.isActive;
  } else if (PageName === "SECURITYMEASUREMASTER") {
    handler =
      `${SystemService_URL}/deleteSecurityMeasureMaster?securityMeasureId=` +
      props.securityMeasureId +
      `&active=` +
      props.isActive;
  } else if (PageName === "SECURITYTYPEMASTER") {
    handler =
      `${SystemService_URL}/deleteSecurityMeasureMaster?securityMeasureTypeId=` +
      props.securityMeasureTypeId +
      `&active=` +
      props.isActive;
  } else if (PageName === "COMPANYMASTERUSERLISTING") {
    handler =
      `${UserService_URL}/activeInactiveUser?userId=` +
      props.id +
      `&status=` +
      props.status;
  }

  return (dispatch) =>
    axios({
      method: "post",
      // data: value,
      url: handler,
      headers: {
        Authorization: "Bearer " + props.access_token,
      },
    })
      .then((response) => {
        dispatch(updateStatusRequest());
        if (response.status === 200) {
          dispatch(updateStatusSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(updateStatusFailure(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(updateStatusFailure(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(updateStatusFailure(err));
              break;
            case 500:
              dispatch(updateStatusFailure("Server Error"));
              break;
            default:
              dispatch(updateStatusFailure("Unknown Error"));
              break;
          }
        } else {
          // dispatch(logout());
        }
      });
}

export function getHistoryIndi(props) {
  return (dispatch) =>
    axios({
      method: "post",
      url:
        `${SystemService_URL}/getHistoryFeedByCompanyIdAndEntityAndId?entityId=` +
        props.entityId +
        `&entityType=` +
        props.entityType,
      headers: {
        authorization: "Bearer " + props.access_token,
      },
    }).then((response) => {
      if (response.status >= 200 && response.status < 300) {
        return response.data;
      } else if (response.status >= 401 && response.status < 500) {
        return response;
      } else {
        //dispatch(clearLogoutData());
        const error = new Error(response.statusText);
        // throw error;
        return error;
      }
    });
}
export function getHistory(props) {
  return (dispatch) =>
    axios({
      method: "post",
      url:
        `${SystemService_URL}/getHistoryFeedByCompanyIdAndEntity?entityType=` +
        props.entityType,
      headers: {
        authorization: "Bearer " + props.access_token,
      },
    }).then((response) => {
      if (response.status >= 200 && response.status < 300) {
        return response.data;
      } else if (response.status >= 401 && response.status < 500) {
        return response;
      } else {
        //dispatch(clearLogoutData());
        const error = new Error(response.statusText);
        // throw error;
        return error;
      }
    });
}

//////////////////////Update Active Inactive Location Status/////////////////////////////
export function downloadHistoryPdf(props) {
  return (dispatch) =>
    axios({
      method: "post",
      url:
        `${SystemService_URL}/downloadHistoryInPdf?entityType=` +
        props.entityType,
      headers: {
        authorization: "Bearer " + props.access_token,
      },
    }).then((response) => {
      if (response.status >= 200 && response.status < 300) {
        return response;
      } else if (response.status >= 401 && response.status < 500) {
        return response;
      } else {
        //dispatch(clearLogoutData());
        const error = new Error(response.statusText);
        // throw error;
        return error;
      }
    });
}
